import React from "react";
import { loginWithDiscord } from "../lib/authApi";
import { useAuth } from "../auth/AuthProvider";
import { Navigate } from "react-router-dom";

export default function Login() {
    const { user, loading } = useAuth();

    if (loading) return null;

    if (user) {
        return <Navigate to="/manager" replace />;
    }

    return (
        <div className="card">
            <h1>Login</h1>

            <p style={{ marginTop: 0 }}>
                Melde dich mit deinem freigegebenen Discord Account an.
            </p>

            <button className="btn" type="button" onClick={loginWithDiscord}>
                Mit Discord anmelden
            </button>
        </div>
    );
}